import axios from 'axios'
import { apiURL, commonHeadersWeb, getCountryCode, getMainLanguageCode } from 'src/consumer/services'

/** Path used for login requests (for 401 interceptor to skip handling login 401s) */
export const LOGIN_PATH = '/api/secure/user/login'

export async function SignIn(email, password) {
  const countryCode = getCountryCode()
  const languageCode = getMainLanguageCode()
  const normalizedEmail = typeof email === 'string' ? email.trim() : email
  try {
    const res = await axios.get(
      `${apiURL}${LOGIN_PATH}?languageCode=${languageCode}&countryCode=${countryCode}`,
      {
        headers: {
          ...commonHeadersWeb,
          'ef-user-country-code': countryCode,
          'ef-app-language': languageCode,
        },
        auth: {
          username: normalizedEmail,
          password: password,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}

/** For 401 interceptor: skip session-expired handling when 401 is from login (wrong password) */
export const getLoginPath = () => LOGIN_PATH
